import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { useNavigate } from "@tanstack/react-router";
import type { JSX } from "react";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { ListWrapper } from "../ListWrapper";

export const NoMessages = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <ListWrapper className="flex flex-col items-center justify-center !space-y-4">
      <div className="flex flex-col items-center justify-center space-y-2">
        <Typography.TitleMd weight="font-bold">
          {t("messaging.no_messages")}
        </Typography.TitleMd>
        <Typography.BodyMd>
          {t("header_v3.send_new_dm_description")}
        </Typography.BodyMd>
      </div>
      <Button
        variant="circle"
        className="mt-4"
        onClick={() => {
          void navigate({ to: "/messages/$uuid", params: { uuid: "new" } });
        }}
      >
        {t("header_v3.send_new_dm")}
      </Button>
    </ListWrapper>
  );
};
